"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.enrichBrokenAlertsInfo = void 0;
// (C) 2021-2022 GoodData Corporation
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var sdk_model_1 = require("@gooddata/sdk-model");
var translationUtils_1 = require("./translationUtils");
var model_1 = require("../../../../../../model");
/**
 * Takes basic broken alert info and adds additional information used for displaying of such filters to the user.
 *
 * @param brokenAlertFilters - the basic broken alert filters info to enrich
 * @param intl - the intl object used
 * @param dateFormat - the date format to be used
 * @param dateDataSets - all available date data sets
 * @param attributeFiltersMeta - additional information about attribute filters (see {@link IAttributeFilterMetaCollection} for details)
 */
function enrichBrokenAlertsInfo(brokenAlertFilters, intl, dateFormat, dateDataSets, attributeFiltersMeta) {
    return brokenAlertFilters.map(function (brokenFilter) {
        if (model_1.isBrokenAlertAttributeFilterInfo(brokenFilter)) {
            return enrichBrokenAttributeFilter(brokenFilter, attributeFiltersMeta);
        }
        if (model_1.isBrokenAlertDateFilterInfo(brokenFilter)) {
            return enrichBrokenDateFilter(brokenFilter, intl, dateFormat, dateDataSets);
        }
        throw new sdk_backend_spi_1.UnexpectedError("Unknown broken alert filter type.");
    });
}
exports.enrichBrokenAlertsInfo = enrichBrokenAlertsInfo;
function enrichBrokenDateFilter(brokenFilter, intl, dateFormat, dateDataSets) {
    var _a;
    var alertFilter = brokenFilter.alertFilter, brokenType = brokenFilter.brokenType;
    var dateFilterTitle = translationUtils_1.translateDateFilter(alertFilter, intl, dateFormat);
    var matchingDateDataset = dateDataSets.find(function (dataset) {
        return sdk_model_1.areObjRefsEqual(dataset, alertFilter.dateFilter.dataSet);
    });
    return {
        type: "date",
        brokenType: brokenType,
        dateFilterTitle: dateFilterTitle,
        title: (_a = matchingDateDataset === null || matchingDateDataset === void 0 ? void 0 : matchingDateDataset.title) !== null && _a !== void 0 ? _a : intl.formatMessage({ id: "kpiAlertDialog.brokenAlertDefaultDateLabel" }),
    };
}
function enrichBrokenAttributeFilter(brokenFilter, attributeFiltersMeta) {
    var alertFilter = brokenFilter.alertFilter, brokenType = brokenFilter.brokenType;
    var metaKey = sdk_model_1.objRefToString(alertFilter.attributeFilter.displayForm);
    var meta = attributeFiltersMeta[metaKey];
    var isNegative = alertFilter.attributeFilter.negativeSelection;
    var totalCount = meta.totalElementsCount;
    var elements = meta.validElements.filter(function (element) {
        var isInSelected = sdk_model_1.isAttributeElementsByRef(alertFilter.attributeFilter.attributeElements)
            ? alertFilter.attributeFilter.attributeElements.uris.some(function (uri) { return uri === element.uri; })
            : alertFilter.attributeFilter.attributeElements.values.some(function (value) { return value === element.title; });
        return isInSelected !== isNegative;
    });
    var selection = elements.map(function (el) { return el.title; }).join(", ");
    var title = meta.title;
    var selectedCount = sdk_model_1.attributeElementsCount(alertFilter.attributeFilter.attributeElements);
    return {
        type: "attribute",
        brokenType: brokenType,
        isAllSelected: isNegative && sdk_model_1.attributeElementsIsEmpty(alertFilter.attributeFilter.attributeElements),
        selection: selection,
        selectionSize: isNegative ? totalCount - selectedCount : selectedCount,
        title: title,
    };
}
//# sourceMappingURL=brokenFilterUtils.js.map